import s from './index.module.less';

// 三段式标签只概括已有正文；线框与流动粒子为视觉意象，不表示运行监控或性能曲线。
export const projectScenes = {
    '智能问数 Agent：业务自助分析与 Lattice 数仓协同': {code: 'QUERY INTELLIGENCE', flow: ['业务语义', '受控查询', '结果核验'], sources: [1, 1, 3]},
    'Game Factory：自然语言驱动的游戏生成 Agent': {code: 'GAME FACTORY', flow: ['创意定义', '生成与校验', '运行隔离'], sources: [6, 6, 6]},
    '企业知识库：知识编译、证据检索与 Agentic 调查': {code: 'KNOWLEDGE ENGINE', flow: ['知识编译', '证据检索', 'Agentic 调查'], sources: [6, 6, 6]},
    'LatticeFlow 高速数仓：Rust 计算内核与实时数据平台': {code: 'LATTICE / FLOW', flow: ['源事件', '确定性计算', '业务指标'], sources: [5, 5, 5]},
    'BILM 高性能关系索引与持久化系统（Go）': {code: 'RELATION MATRIX', flow: ['关系索引', '集合运算', '持久化恢复'], sources: [3, 3]},
    '全球站推荐：用户节奏感知的受约束收益优化推荐系统': {code: 'DECISION ENGINE', flow: ['用户状态', '多目标排序', '风险约束'], sources: [1, 2, 3]},
    '达人智选：多链路召回与社交协同驱动的KOL智能推荐系统': {code: 'SOCIAL INTELLIGENCE', flow: ['语义召回', '圈层分发', '社交协同'], sources: [0, 2, 3, 4]},
    '自动化数据分析管线': {code: 'ANALYTICS ENGINE', flow: ['自然语言', '工具编排', '分析洞察'], sources: [1, 3, 3]},
    '星瞳 text2motion 动作生成系统': {code: 'TEXT TO MOTION', flow: ['指令理解', '动作检索', '姿态合成'], sources: [3, 3]},
    '基于强化学习的碳中和政策模拟系统': {code: 'POLICY SIMULATION', flow: ['策略训练', '场景模拟', '因果解释'], sources: [1, 1, 1]},
};

const ProjectScene = () => <div className={s.projectScene} aria-hidden='true'>
    <div className={s.sceneAura} />
    <svg viewBox='0 0 400 240' fill='none' className={s.sceneStructure}>
        <g className={s.sceneGrid}>
            {[0, 1, 2, 3, 4, 5].map((i) => <path key={i} d={`M ${20 + i * 40} 165 L ${180 + i * 40} 225 M ${180 + i * 40} 165 L ${20 + i * 40} 225`} />)}
        </g>
        <g className={s.sceneOrbit}>
            <ellipse cx='205' cy='132' rx='164' ry='62' transform='rotate(-22 205 132)' />
            <ellipse cx='205' cy='132' rx='143' ry='50' transform='rotate(24 205 132)' />
        </g>
        <g className={s.sceneCore}>
            <path className={s.sceneFacet} d='M 205 44 L 278 85 L 205 127 L 132 85 Z' />
            <path className={s.sceneFacet} d='M 132 85 L 205 127 L 205 208 L 132 166 Z' />
            <path className={s.sceneFacet} d='M 205 127 L 278 85 L 278 166 L 205 208 Z' />
            {[0, 1, 2, 3].map((i) => <path className={s.sceneSlice} key={i} d={`M 132 ${101 + i * 17} L 205 ${143 + i * 17} L 278 ${101 + i * 17}`} />)}
            <path d='M 169 65 L 242 106 L 242 186 M 242 65 L 169 106 L 169 186' />
            <path className={s.scenePulse} d='M 132 85 L 205 127 L 278 85 M 205 127 L 205 208' />
        </g>
        <g className={s.sceneConnections}>
            <path d='M 18 114 H 81 L 132 85 M 278 85 L 319 62 H 382 M 278 166 L 320 191 H 378' />
            <path className={s.scenePackets} d='M 18 114 H 81 L 132 85 L 205 127 L 278 85 L 319 62 H 382' />
            <path className={s.scenePackets} d='M 205 127 V 208 L 278 166 L 320 191 H 378' />
            {[[18, 114], [382, 62], [378, 191], [205, 44], [205, 208]].map(([x, y]) => <circle key={`${x}-${y}`} cx={x} cy={y} r='3' />)}
        </g>
    </svg>
    <span className={s.sceneGlyphA}>{'{ λ }'}</span>
    <span className={s.sceneGlyphB}>{'⌁ ᵕ̈ ⌁'}</span>
</div>;

export default ProjectScene;
